import React from 'react';

const CompanyHighlights = ({ lang }) => {
  const isRtl = lang === 'ar';

  const stats = [
    { id: 1, number: "08", label: isRtl ? "سنوات خبرة" : "Years Exp" },
    { id: 2, number: "100", label: isRtl ? "منتج معتمد" : "Products" },
    { id: 3, number: "500", label: isRtl ? "موظف" : "Employee" },
    { id: 4, number: "5000", label: isRtl ? "طن شهريًا" : "Tons / Month" },
  ];

  const sectors = [
    { title: isRtl ? "القطاع الصناعي" : "Industrial", icon: "🏭", desc: isRtl ? "حلول كيميائية" : "Chemical solutions" },
    { title: isRtl ? "القطاع الصحي" : "Healthcare", icon: "🏥", desc: isRtl ? "تعقيم وحماية" : "Medical protection" },
    { title: isRtl ? "قطاع الفنادق" : "Hospitality", icon: "🏨", desc: isRtl ? "رفاهية ونظافة" : "Luxury cleaning" },
    { title: isRtl ? "المنزلي" : "Home Care", icon: "🏠", desc: isRtl ? "عناية آمنة" : "Safe daily care" },
    { title: isRtl ? "العناية بالسيارات" : "Car Care", icon: "🚗", desc: isRtl ? "حماية وعناية" : "Safe and Reliable" },
  ];

  return (
    <section className="creative-section" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="container-pro">
        
        <div className="main-header-box">
          <div className="side-line"></div>
          <h2 className="creative-title">
            {isRtl ? "قوة " : "The Power of "}
            <span className="outline-text">{isRtl ? "الإنجاز" : "Impact"}</span>
          </h2>
        </div>

        <div className="main-grid-layout">
          {/* منطقة الإحصائيات - دوائر عائمة في الشاشات الكبيرة وشبكة في الصغيرة */}
          <div className="stats-visual-area">
            {stats.map((s, index) => (
              <div key={s.id} className={`stat-circle circle-${index + 1}`}>
                <span className="big-num-bg">{s.number}</span>
                <div className="stat-content-inner">
                  <h4>{s.number}+</h4>
                  <p>{s.label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* منطقة القطاعات */}
          <div className="sectors-modern-list">
            {sectors.map((sec, idx) => (
              <div key={idx} className="sector-capsule-card">
                <div className="capsule-icon-box">{sec.icon}</div>
                <div className="capsule-text">
                  <h3>{sec.title}</h3>
                  <p>{sec.desc}</p>
                </div>
                <div className="capsule-arrow">{isRtl ? "←" : "→"}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .creative-section { 
          padding: 80px 5%; 
          background: #ffffff; 
          position: relative; 
          overflow: hidden; 
        }
        .container-pro { max-width: 1300px; margin: 0 auto; }

        .main-header-box { margin-bottom: 50px; display: flex; align-items: center; gap: 15px; }
        .side-line { width: 50px; height: 3px; background: #d4af37; border-radius: 10px; }
        .creative-title { font-size: clamp(1.8rem, 4vw, 3rem); font-weight: 900; color: #1a3a5a; margin: 0; }
        .outline-text { color: transparent; -webkit-text-stroke: 1px #d4af37; }

        /* الشبكة الرئيسية */
        .main-grid-layout { 
          display: grid; 
          grid-template-columns: 1.2fr 0.8fr; 
          gap: 40px; 
          align-items: start; 
        }

        /* منطقة الدوائر */
        .stats-visual-area {
          position: relative;
          height: 500px;
          width: 100%;
          z-index: 2;
        }

        .stat-circle {
          position: absolute;
          background: #fff;
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-shadow: 0 15px 35px rgba(0,0,0,0.07);
          transition: 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: default;
          border: 1px solid #f9f9f9;
        }

        @keyframes floatEffect {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }

        /* توزيع الدوائر للشاشات الكبيرة */
        .circle-1 { width: 180px; height: 180px; top: 0; left: 10%; animation: floatEffect 5s infinite ease-in-out; }
        .circle-2 { width: 150px; height: 150px; top: 10%; right: 10%; animation: floatEffect 6s infinite ease-in-out 1s; }
        .circle-3 { width: 210px; height: 210px; bottom: 5%; left: 15%; animation: floatEffect 7s infinite ease-in-out 0.5s; }
        .circle-4 { width: 170px; height: 170px; bottom: 15%; right: 15%; animation: floatEffect 5.5s infinite ease-in-out 1.5s; }

        .big-num-bg { position: absolute; font-size: 4rem; font-weight: 900; color: rgba(212, 175, 55, 0.05); z-index: -1; }
        .stat-content-inner h4 { font-size: clamp(1.5rem, 3vw, 2.2rem); margin: 0; color: #1a3a5a; font-weight: 800; line-height: 1; }
        .stat-content-inner p { font-size: 0.85rem; margin: 5px 0 0; color: #d4af37; font-weight: 700; text-align: center; }

        .stat-circle:hover {
          background: #1a3a5a;
          transform: scale(1.05) !important;
          z-index: 10;
        }
        .stat-circle:hover h4, .stat-circle:hover p { color: #fff; }

        /* قائمة الكبسولات */
        .sectors-modern-list { display: flex; flex-direction: column; gap: 15px; }
        .sector-capsule-card {
          background: #fdfdfd; 
          padding: 15px 25px; 
          border-radius: 100px;
          display: flex; 
          align-items: center; 
          gap: 15px;
          border: 1px solid #f0f0f0; 
          transition: 0.3s ease;
          cursor: pointer;
        }
        .capsule-icon-box { 
          width: 50px; height: 50px; 
          background: #fff; 
          border-radius: 50%; 
          display: flex; align-items: center; justify-content: center; 
          font-size: 1.4rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.03);
        }
        .capsule-text h3 { font-size: 1.05rem; color: #1a3a5a; margin: 0; font-weight: 800; }
        .capsule-text p { font-size: 0.75rem; color: #888; margin: 0; }
        .capsule-arrow { margin-inline-start: auto; color: #d4af37; font-weight: bold; transition: 0.3s; }

        .sector-capsule-card:hover { 
          background: #d4af37; 
          border-color: #d4af37; 
          transform: scale(1.02);
        }
        .sector-capsule-card:hover h3, .sector-capsule-card:hover p, .sector-capsule-card:hover .capsule-arrow { color: #fff; }

        /* التجاوب مع الشاشات المتوسطة (Tablets) */
        @media (max-width: 1024px) {
          .main-grid-layout { grid-template-columns: 1fr; gap: 40px; }
          .stats-visual-area { height: 450px; max-width: 600px; margin: 0 auto; }
        }

        /* التجاوب مع الشاشات الصغيرة (Mobile) */
        @media (max-width: 768px) {
          .creative-section { padding: 60px 20px; }
          .stats-visual-area { 
            height: auto; 
            display: grid; 
            grid-template-columns: 1fr 1fr; 
            gap: 15px; 
            margin-bottom: 30px;
          }
          .stat-circle { 
            position: static; 
            width: 100% !important; 
            height: auto !important; 
            padding: 30px 15px;
            border-radius: 20px; 
            animation: none !important;
          }
          .big-num-bg { display: none; }
          .sector-capsule-card { border-radius: 20px; padding: 12px 20px; }
        }

        @media (max-width: 480px) {
          .main-header-box { flex-direction: column; align-items: flex-start; gap: 10px; }
          .stats-visual-area { grid-template-columns: 1fr 1fr; }
          .stat-content-inner h4 { font-size: 1.5rem; }
          .capsule-icon-box { width: 40px; height: 40px; font-size: 1.1rem; }
          .capsule-text h3 { font-size: 0.95rem; }
        }
      `}</style>
    </section>
  );
};

export default CompanyHighlights;